export const pageTitle = 'Admin Tasks | Pineapple Labs';
export const emptySetText = 'Nothing urgent is going on.';
